import PropTypes from "prop-types"
import React from "react"
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css"
import { Link } from "react-router-dom"

import {
  Container,
  Col,
  Row,
  Card,
  CardBody,
  CardTitle,
  CardSubtitle,
  CardImg,
  CardText,
  CardHeader,
  CardImgOverlay,
  CardFooter,
  CardDeck,
  Button,
} from "reactstrap"

//import components
import Breadcrumbs from "../../components/Common/Breadcrumb"

//i18n
import { withTranslation } from "react-i18next"

const DemoGrid = props => {
  //meta title
  document.title = "DemoGrid | CampusVirtual"

  return (
    <React.Fragment>
      <div className="page-content border border-danger">
        <Container fluid className="border border-black mt-0">
          <div className="">
            <h5>Basic Columns</h5>
            <div className="row border bg-info">
              <div className="col border bg-secondary">column</div>
              <div className="col border bg-success">column</div>
            </div>
            <h5>Basic Columns</h5>
            <div className="row border bg-info">
              <div className="col border bg-secondary">column</div>
              <div className="col border bg-success">column</div>
              <div className="col border bg-info">column</div>
            </div>
          </div>
          <h5>CardBody</h5>
          <div className="row border bg-info">
            <div className="col border bg-secondary">column</div>
            <div className="col border bg-info mt-2">
              {" "}
              <Card>
                <h5 className="card-header bg-transparent border-bottom text-uppercase">
                  Featured
                </h5>
                <CardBody>
                  <CardTitle className="mt-0">
                    Special title treatment
                  </CardTitle>
                  <CardText>
                    With supporting text below as a natural lead-in to
                    additional content.
                  </CardText>
                  <Link to="#" className="btn btn-primary">
                    Go somewhere
                  </Link>
                </CardBody>
              </Card>
            </div>
          </div>
        </Container>
      </div>
    </React.Fragment>
  )
}

DemoGrid.propTypes = {
  t: PropTypes.any,
  chartsData: PropTypes.any,
  onGetChartsData: PropTypes.func,
}

export default withTranslation()(DemoGrid)
